import React from 'react';
import { Helmet } from 'react-helmet';

const Head = () => (
	<Helmet />
);

export default Head;

